import React from 'react'
import Popover from '../../../../components/ui/popover'
import Button from '../../../../components/ui/button'
import { EMOTIONS } from '../../podcast-editor-page'

interface MoodSelectorProps {
    emotion?: string
    onChange: (emotion: string) => void
    disabled?: boolean
}

export const MoodSelector: React.FC<MoodSelectorProps> = ({ emotion, onChange, disabled }) => {
    const currentEmotion = EMOTIONS.find(e => e.value === emotion) || EMOTIONS[0]
    const [emoji, ...labelParts] = currentEmotion.label.split(' ')
    const labelText = labelParts.join(' ')

    return (
        <Popover
            trigger={(props) => (
                <Button
                    ref={props.ref}
                    onClick={props.onClick}
                    onMouseEnter={props.onMouseEnter}
                    onMouseLeave={props.onMouseLeave}
                    variant="ghost"
                    size="sm"
                    className="h-7 px-2 text-xs gap-1.5 border border-dashed border-border aspect-square w-7 p-0"
                    disabled={disabled}
                    title={`Change mood: ${labelText}`}
                >
                    <span className="text-sm leading-none">{emoji}</span>
                </Button>
            )}
            className="w-40 p-1"
        >
            <div className="grid gap-0.5">
                {EMOTIONS.map(e => {
                    const isSelected = e.value === currentEmotion.value
                    return (
                        <Button
                            key={e.value}
                            variant={isSelected ? "secondary" : "ghost"}
                            size="sm"
                            className="justify-start h-8 px-2 font-normal w-full"
                            onClick={() => onChange(e.value)}
                        >
                            <span className="mr-2 text-sm">{e.label.split(' ')[0]}</span>
                            {e.label.split(' ').slice(1).join(' ')}
                        </Button>
                    )
                })}
            </div>
        </Popover>
    )
}
